export const NotFound: React.FC = () => {
  return <>Not Found!</>;
};
